const GTM_ID = 'GTM-KZQDRMM';
const DATA_LAYER_KEY = 'dataLayer';
const GTM_SRC = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`;

const gtm = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  try {
    const dataLayerName = DATA_LAYER_KEY;
    const scripts = document.getElementsByTagName('script');
    const existingScript =
      document.querySelector(`script[data-gtm-id="${GTM_ID}"]`) ||
      document.querySelector(`script[src^="${GTM_SRC}"]`);

    if (existingScript) {
      return;
    }

    const dataLayer = (window[dataLayerName] = window[dataLayerName] || []);
    const now = Date.now();

    dataLayer.push({
      'gtm.start': now,
      event: 'gtm.js',
    });

    dataLayer.push({
      event: 'changeRoute',
    });

    const scriptElement = document.createElement('script');
    scriptElement.async = true;
    scriptElement.src = GTM_SRC;
    scriptElement.dataset.gtmId = GTM_ID;

    const firstScript = scripts.length > 0 ? scripts[0] : null;
    const parentNode = firstScript?.parentNode ?? document.head ?? document.body;

    if (parentNode && firstScript) {
      parentNode.insertBefore(scriptElement, firstScript);
      return;
    }

    const fallbackParent = document.head ?? document.body;
    fallbackParent?.appendChild(scriptElement);
  } catch (error) {
    // Silently ignore GTM bootstrap issues so the app keeps working
    // eslint-disable-next-line no-console
    console.warn('GTM bootstrap failed', error);
  }
};

export default gtm;
